module.exports = __webpack_public_path__ + "img/mcc_logo.1c76ff55.svg";